<template>
  <el-dialog :visible="true" fullscreen @close="$emit('close')">
    <p class="error">{{ error }}</p>

    <qrcode-stream
      :camera="camera"
      @decode="onDecode"
      @init="onInit"
    />
    <template #footer>
      <div>
        <el-button :disabled="!result" @click="reScan">重新掃碼</el-button>
        <el-button
          type="primary"
          :disabled="!result"
          @click="$emit('save', result)"
          >確認</el-button
        >
      </div>
    </template>
    <p class="decode-result">
      <b>{{ result }}</b>
    </p>
  </el-dialog>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";

export default {
  components: { QrcodeStream },

  data() {
    return {
      camera: "auto",
      result: "",
      error: "",
    };
  },

  methods: {
    // 識別成功回調
    onDecode(result) {
      this.result = result;
      this.pause();
    },
    // 啟動相機
    unpause() {
      this.camera = "auto";
    },
    // 禁用相機
    pause() {
      this.camera = "off";
    },
    // 重新掃碼
    reScan() {
      this.result = "";
      this.unpause();
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
      }
    },
  },
};
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
.decode-result {
  color: #38959d;
}
</style>